export const getEntityById = (entity, id) => (state) => state.entities[entity]?.byId[id];
